import { createApp } from '@wu/widget-core';
import { JobBoard } from './job-board';
import { meta } from './meta';

export default createApp(
  { alias: meta.appAlias, name: meta.appName },
  JobBoard
);
